import { Answer, Question } from "types";
import { Country } from "./interfaces";
import { DynamicFormAPI, KYCQuestionType } from "types/enums";
import { KYCDataDto } from "./DTOs/KYCDtos";

export const isRequired = (question: Question, formState: any): boolean => {
    if (formState) {
        //NOTE(tonim): Disabled until taxationNumberNotGranted is implemented in cLA
        // if (
        //     question.name.startsWith("countriesWithTaxation") &&
        //     question.name.endsWith("taxationNumber")
        // ) {
        //     const index = Number(question.name.split("[")[1].split("]")[0]);
        //     return (
        //         formState.countriesWithTaxation[index] &&
        //         !formState.countriesWithTaxation[index].taxationNumber
        //     );
        // }
        if (
            question.name.startsWith("countriesWithTaxation") &&
            question.name.endsWith("taxationNumber")
        ) {
            const index = Number(question.name.split("[")[1].split("]")[0]);
            return (
                formState.countriesWithTaxation[index] &&
                formState.countriesWithTaxation[index].taxationCountry
            );
        }

        switch (question.name) {
            case "politicallyExposedReason":
                return formState.politicallyExposed;

            case "incomingOutgoingForeignPayments":
                return (
                    formState.incomingOutgoingForeignPaymentsPcs &&
                    formState.incomingOutgoingForeignPaymentsPcs !== "0"
                );

            case "incomingOutgoingForeignPaymentsPcs":
                return (
                    formState.incomingOutgoingForeignPayments &&
                    formState.incomingOutgoingForeignPayments !== "0"
                );

            case "incomingOutgoingForeignPaymentsCountries":
                return (
                    formState.incomingOutgoingForeignPayments &&
                    formState.incomingOutgoingForeignPayments !== "0" &&
                    formState.incomingOutgoingForeignPaymentsPcs &&
                    formState.incomingOutgoingForeignPaymentsPcs !== "0"
                );

            case "originOfFundsEarnings":
            case "originOfFundsInvestments":
            case "originOfFundsSaleOfProperty":
            case "originOfFundsGift":
            case "originOfFundsBusinessIncome":
                return !formState.customerHasNoAssets;

            default:
                return question.mandatory;
        }
    }

    return true;
};

export const mapCountryAnswers = (
    params:
        | { filter: string; answers: Answer[]; countries: undefined }
        | { filter: string; countries: Country[]; answers: undefined }
): {
    label: string;
    value: string;
}[] => {
    if (params.answers) {
        return [
            ...params.answers
                .filter((a) => a.titleFI === params.filter)
                .map((a) => {
                    return {
                        label: a.titleFI,
                        value: a.externalId,
                    };
                }),
            ...params.answers
                .filter((a) => a.titleFI !== params.filter)
                .map((a) => {
                    return {
                        label: a.titleFI,
                        value: a.externalId,
                    };
                }),
        ];
    } else {
        return [
            ...params
                .countries!.filter((a) => a.countryNameFI === params.filter)
                .map((a) => {
                    return {
                        label: a.countryNameFI,
                        value: a.countryCode,
                    };
                }),
            ...params
                .countries!.filter((a) => a.countryNameFI !== params.filter)
                .map((a) => {
                    return {
                        label: a.countryNameFI,
                        value: a.countryCode,
                    };
                }),
        ];
    }
};

export const mapCheckboxAnswers = (
    question: {
        id: string;
        name: string;
        answers?: Answer[];
        hasPredefinedAnswers: boolean;
        api?: DynamicFormAPI;
        questionType?: KYCQuestionType;
    },
    data: KYCDataDto
) => {
    if (question.questionType !== KYCQuestionType.CheckBox) {
        return data[question.name];
    } else {
        if (question.answers) {
            const searchCriteria = data[question.name] ? "Kyllä" : "Ei";

            const answer = question.answers.find(
                (a) => a.titleFI === searchCriteria
            );
            return answer && answer.externalId;
        }
    }
};



// WEBPACK FOOTER //
// ./src/util/kycUtils.ts